const RENEWED = {id: 1, name: 'Renewed', className: 'renewed'}
const UNDER_RENEWAL = {id: 2, name: 'Under renewal', className: 'under-renewal'}
const TO_BE_RENEWED = {id: 3, name: 'To be renewed', className: 'to-be-renewed'}
const EXPIRE = {id: 4, name: 'Expired', className: 'expire'}
const LIQUIDATED = {id: 5, name: 'Liquidated', className: 'liquidated', alt: 'Cancelled'}

const expireStatus = [
  RENEWED,
  UNDER_RENEWAL,
  TO_BE_RENEWED,
  EXPIRE,
  LIQUIDATED
]

export {
  expireStatus,
  RENEWED,
  UNDER_RENEWAL,
  TO_BE_RENEWED,
  EXPIRE,
  LIQUIDATED
}



// WEBPACK FOOTER //
// ./src/constants/expireStatus.js